import ProductsHeader from "components/pages/products-page/products-header";
import { Box } from "components/common";
import Products from "./products";

export default function ProductsMain() {
  return (
    <Box
      sx={{
        maxWidth: "1200px",
        margin: "auto",
      }}
    >
      <ProductsHeader />
      <Products />
    </Box>
  );
}
